import AdministrationToolbar from './AdministrationToolbar'

export default AdministrationToolbar
